<template>
  <div class="container py-5">

    <div class="level">
      <search-autocomplete
        class="level-right" 
        :value="filters.project_id" 
        @input="setFilter({
          field: 'project_id', 
          value: $event
        })"/>
    </div>

    <article 
      v-if="!firstLoad && slabs.length == 0" 
      class="message is-info is-fullwidth">
      <div class="message-body">
        There are no slabs.
      </div>
    </article>

    <table 
      class="table is-fullwidth is-hoverable has-small-font">

      <thead>
        <tr>
          <th 
            v-for="(header, headerIndex) in headers"
            :key="headerIndex">
            {{ header }}
          </th>
        </tr>
        <tr v-if="loading">
          <th :colspan="headers.length" class="py-0 px-0 is-naked">
            <v-progress class="is-fullwidth" v-model="loading"/>
          </th>
        </tr>
      </thead>

      <v-fade-transition>
        <tbody v-if="slabs.length > 0">
          <tr
            class="v-centered"
            v-for="slab in slabs"
            :key="slab.id">

            <td>
              {{ slab.production_sheet.project.project_name }}
            </td>
            <td>
              <router-link
                :to="{ 
                  'name': 'ProductionSheetViewer',
                  params: { 
                    productionSheetId: slab.production_sheet.id 
                  }
                }">
                {{ slab.production_sheet.name }}
              </router-link>
            </td>
            <td>
              <a 
                v-if="slab.production_sheet.image"
                @click="
                  preview.src = slab.production_sheet.image; 
                  preview.state = true"
                target="_blank">
                attachment
              </a>
            </td>
            <td>
              <div class="help">
                {{ slab.backing_product_master ? 
                  slab.backing_product_master.name : '' }}
              </div>
              <div class="help">
                T{{ slab.b_thick_in_str }}"
              </div>
            </td>
            <td>
              <div class="help">
                {{ slab.facing_product_master ? 
                  slab.facing_product_master.name : '' }}
              </div>
              <div class="help">
                T{{ slab.f_thick_in_str }}"
              </div>
            </td>
            <td>
              {{ slab.finishing_step.name }}
            </td>
            <td>
              {{ lwt(slab.slab_stocking_unit) }}
            </td>
            <td>
              {{ slab.finished_qty }}
            </td>
            <td>
              <div class="buttons buttons-right">

                <button 
                  @click="updateSlab({
                    slabId: slab.id,
                    data: { make_in_house: true }
                  })"
                  :class="{ 'is-primary': slab.make_in_house }"
                  class="button">
                  <span v-if="slab.make_in_house">
                    Making in-house
                  </span>
                  <span v-else>
                    Make in-house
                  </span>
                </button>

                <button 
                  @click="updateSlab({
                    slabId: slab.id,
                    data: { make_in_house: false }
                  })"
                  :class="{ 
                    'is-primary': slab.make_in_house != null && slab.make_in_house == false 
                  }"
                  class="button">
                  <span v-if="slab.make_in_house != null && slab.make_in_house == false">
                    Purchasing
                  </span>
                  <span v-else>
                    Purchase
                  </span>
                </button>
                
              </div>
            </td>

          </tr>
        </tbody>
      </v-fade-transition>

    </table>

    <v-file-preview
      v-if="preview.src"
      :src="preview.src"
      :tag="preview.src.includes('pdf') ? 'iframe' : 'img'"
      v-model="preview.state"/>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
import VFilePreview from '@/components/base/VFilePreview'
import VProgress from '@/components/base/VProgress'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import SearchAutocomplete from '@/components/projects/SearchAutocomplete'

import { mapState, mapActions, mapMutations } from 'vuex'

import { parseISO, format } from 'date-fns'

export default {
  components: { 
    VPagination,
    VFilePreview,
    VProgress,
    VFadeTransition,
    SearchAutocomplete
  },
  data() {
    return {
      headers: [
        'Project', 'Production Sheet Name', 'Drawing', 
        'Backing', 'Facing', 'Finishing', 'Finished Dimensions', 
        'Quantity', 'Make In-house'
      ],
      parse: (d) => {
        return d ? parseISO(d) : null
      },
      format: (d) => {
        return d ? format(d, 'yyyy-MM-dd H:mm:ss') : null
      },
      preview: {
        state: false,
        src: null
      }
    }
  },
  created() {
    this.initialize();
  },
  computed: {
    ...mapState("productionSheetItems", [
      "slabs", "pagination", "loading", "firstLoad", "filters"
    ])
  },
  watch: {
    'pagination.page'() {
      this.getSlabs(this.pagination);
    },
    filters: {
      handler() {
        this.getSlabs(this.filters);
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("productionSheetItems", [
      "getSlabs", "updateSlab"
    ]),
    ...mapMutations("productionSheetItems", ["setFilter"]),
    initialize() {
      this.getSlabs();
    },
    lwt(slab) {
      return `L${slab.length_in_str}" x W${slab.width_in_str} x T${slab.thick_in_str}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>